/*
 * Module for creating an ad-hoc (Tableau) workbook
 */

define([
  "jquery",
  "marionette",
  "messaging/messenger",
  "./adHocWorkbooksModalView",
  "modules/reportSplit/groups/adHocWorkbooks/adHocWorkbooksModel",
], function (
  $,
  Marionette,
  Messenger,
  AdHocWorkbooksModalView,
  // eslint-disable-next-line no-unused-vars
  AdHocWorkbooksModel,
) {
  "use strict";

  return Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "workbookItem";
      this.region = options.region;
    },
    show: function (workbook) {
      this.workbook = workbook;
      this.view = new AdHocWorkbooksModalView.adHocWorkbooksModalView({
        model: this.workbook,
      });

      //handle bad save
      workbook.on(
        "invalid",
        function (model, error) {
          //Clear errors first
          this.view.clearErrors();
          if (error["name"]) {
            this.view.nameError(error["name"]);
          }
        },
        this,
      );

      this.view.on(
        "done",
        function () {
          //save model
          workbook.set("name", this.view.getNameValue());

          if (Messenger.reqres.request("save:textbox")) {
            workbook.saveModel({
              success: function () {
                Messenger.vent.trigger("close:modal");
              },
              error: function (model, response) {
                if (response.status === 400) {
                  const errorMessage = Messenger.getErrorFromResponse(response);
                  Messenger.okDialog(
                    $.t("reports.adHoc.workbooks.addError", { message: errorMessage }),
                  );
                } else {
                  Messenger.showErrorFromResponse(response);
                }
              },
            });
          }
        },
        this,
      );

      this.view.on(
        "cancel",
        function () {
          workbook.deleteModel();
          Messenger.vent.trigger("close:modal");
        },
        this,
      );

      this.showRegion(this.view);
    },
  });
});
